var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('register')
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f93293b","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/sign/Register/RegisterContainer.vue
// module id = 856
// module chunks = 0